<template>
  <div>
    <CRow>
      <CCol md="12">
        <BuildingList/>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BuildingList from "../../components/admin/BuildingList";

export default {
  name: "Building_List",
  components: {
    BuildingList,
  },
};
</script>
 